module.exports = __webpack_public_path__ + "img/web_customers_say_02.9bffdfdc.jpg";